
import { useState } from 'react';


export const RetainState = () => {
    const [templates, setTemplates] = useState({ preview: { toggled: false } })
    const [promos, setPromos] = useState({ list: null, current: { value: null, stat: false }, action: { selected: null, modal: false, type: 0, confirmed: false } })
    const [redeem, setRedeem]=useState([])
    const [branch, setBranch]=useState([])
    const [open, setOpen] = useState(false);
    const [loader, setLoader] = useState(false);
    const [formdata, setFormData] = useState({name: "",  points: "", points_to_earn: "", free: 1, promo_start: "", promo_end: "", active: true,  user_id: 1})
    const [isLoader, setIsLoader] = useState(false);
    const [pointdata, setPointData] = useState([])
    const [genForm, setGenForm] = useState({  date: "", branch_id: "", branch_code: "", code_start: 1, no_of_code: "", })
    const [approved, setApproved] = useState ({id:"", name:"", branch_id: "", status: "", user_id:""  })
    const [error, setError]= useState(false)
    const [genList, setGenList] = useState([]) 
    const [openConfirm, setOpenConfirm] = useState(false)
    const [codeList, setCodeList] = useState([])
    const [listLoader, setListLoader] = useState(true)
    const [inftScroll, setInftScroll] = useState(true)
    const [lid, setLid] = useState(0)
    const [limit] = useState(10)
    
    const [loadbtn, setLoadBtn] = useState(false);
    const [confirmmodal, setConfirmModal] = useState(false);
    const [confirmadd, setConfirmAdd] = useState(false);
    const [confirmupdate, setConfirmUpdate] = useState(false);

    const [procodeList, setPromoCodeList] = useState([])
    const [openSuccess, setOpenSuccess] = useState(false)
    const [nameExist, setNameExist] = useState('')
    const [search, setSearch] = useState('')
    const [bForm, setBForm] = useState ({openForm: false, branch_code:"", branch_name: "", active: false, msg: "", id: "", type: ""})

    return {
        templates: { data: templates, set: setTemplates },
        promos: { data: promos, set: setPromos },
        redeem:{data: redeem, set: setRedeem},
        branch:{data: branch, set: setBranch},
        open:{data: open, set: setOpen},
        formdata: { data: formdata, set: setFormData },
        pointdata: { data: pointdata, set: setPointData },
        isLoader: { data: isLoader, set: setIsLoader },
        loader: { data: loader, set: setLoader },
        approved: { data: approved, set: setApproved },
        genForm: {data: genForm, set: setGenForm},
        error: {data: error, set: setError},
        genList: {data: genList, set: setGenList},
        openConfirm: {data: openConfirm, set: setOpenConfirm},
        codeList: {data: codeList, set: setCodeList},
        listLoader: {data: listLoader, set: setListLoader},
        inftScroll: {data: inftScroll, set: setInftScroll},
        lid: {data: lid, set: setLid},
        limit: {data: limit},
        loadbtn: { data: loadbtn, set: setLoadBtn },
        confirmmodal: { data: confirmmodal, set: setConfirmModal },
        confirmupdate: { data: confirmupdate, set: setConfirmUpdate },
        confirmadd: { data: confirmadd, set: setConfirmAdd },
        procodeList: { data: procodeList, set: setPromoCodeList },
        openSuccess: {data: openSuccess, set: setOpenSuccess},
        nameExist: {data: nameExist, set: setNameExist},
        search: {data: search, set: setSearch},
        bForm: {data: bForm, set: setBForm}
    }
}

